$.onmount('[data-component=rack_location]', function () {
  var $el = $(this)
  var variantId = $el.data('variant-id')
  var isEditing = false

  $el.on('click', function (e) {
    if (isEditing) return
    e.preventDefault()

    isEditing = true
    var currentLocation = $el.text().trim()
    if (currentLocation === '-' || currentLocation === 'Click to add') currentLocation = ''

    var $input = $('<input>')
      .attr('type', 'text')
      .attr('placeholder', 'Enter location')
      .addClass('form-control form-control-sm')
      .css({
        'width': '100px',
        'display': 'inline-block',
        'text-align': 'center'
      })
      .val(currentLocation)

    $el.html($input)
    $input.focus().select()

    var saveLocation = function () {
      if (!isEditing) return

      var newLocation = $input.val().trim()

      $el.html('<span class="spinner-border spinner-border-sm"></span>')

      $.ajax({
        url: '/shopify/product_variants/' + variantId + '/update_location',
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          rack_location: newLocation
        },
        success: function (response) {
          if (response.success) {
            var displayLocation = response.rack_location || ''
            $el.text(displayLocation)
            isEditing = false
          } else {
            alert('Error: ' + (response.errors || ['Unknown error']).join(', '))
            $el.text(currentLocation || '')
            isEditing = false
          }
        },
        error: function (xhr) {
          var errorMsg = 'Failed to update location'
          if (xhr.responseJSON && xhr.responseJSON.error) {
            errorMsg = xhr.responseJSON.error
          } else if (xhr.responseJSON && xhr.responseJSON.errors) {
            errorMsg = xhr.responseJSON.errors.join(', ')
          }
          alert(errorMsg)
          $el.text(currentLocation || '')
          isEditing = false
        }
      })
    }

    var cancelEdit = function () {
      $el.text(currentLocation || '')
      isEditing = false
    }

    $input.on('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault()
        saveLocation()
      } else if (e.key === 'Escape') {
        e.preventDefault()
        cancelEdit()
      }
    })

    $input.on('blur', function () {
      setTimeout(saveLocation, 200)
    })
  })
})
